
import { Component, Vue, Prop } from 'vue-property-decorator';
import markdown from 'spa-ionata-admin/lib/services/markdown';
import MediaImg from 'spa-ionata-admin/lib/components/MediaImg.vue';
import Media from 'spa-ionata-admin/lib/models/Media';
import AnOverline from './AnOverline.vue';

@Component({ components: { AnOverline, MediaImg } })
export default class PostLanding extends Vue {
  @Prop([String, Media]) readonly img!: string | Media;

  @Prop(String) readonly overline!: string;

  @Prop(String) readonly title!: string;

  @Prop(String) readonly excerpt!: string;

  @Prop(String) readonly to!: string;

  @Prop(String) readonly buttonLabel!: string;

  @Prop([Number, String]) readonly mdCols!: number | string;

  @Prop(Boolean) readonly bordered!: boolean;

  @Prop(String) readonly imgPosition?: string;

  @Prop({ type: String, default: 'h2' }) readonly titleTag!: 'h1' | 'h2';

  @Prop({ type: Boolean, default: null }) readonly dark!: boolean;

  @Prop({ type: Boolean, default: null }) readonly light!: boolean;

  get imgSrc() {
    const { img } = this;
    return typeof img === 'string' &&
      (img.startsWith('/') || img.startsWith('https://'))
      ? img
      : undefined;
  }

  get imgId() {
    const { img } = this;
    if (img instanceof Media) {
      return img.id;
    }
    if (!this.imgSrc) {
      return img;
    }
    return undefined;
  }

  get md() {
    if (this.mdCols) {
      return parseInt(this.mdCols as string, 10);
    }
    return this.imgSrc || this.imgId ? 6 : 12;
  }

  get markdownExcerpt() {
    return this.excerpt ? markdown(this.excerpt) : '';
  }

  get hasOverlay() {
    return this.imgSrc || this.imgId;
  }

  get isDark() {
    return this.dark || (this.light === null ? true : !this.light);
  }

  get isLight() {
    return !this.isDark;
  }
}
